import { useEffect, useState } from "react";
import { Grid } from '@mui/material';
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { useSpecificAttributeStore } from "../../hooks/useSpecificAttributeStore";
import { SpecificAttributesModal } from "./components/SpecificAttributesModal";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código', align:'center' },
    { type: 'text', field: 'name', label: 'Nombre', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

export const SpecificAttributesView = () => {

    const navigate = useNavigate();
    // const { search } = useSelector(selectHeaderState);

    const { setActionSpecificAttribute, getSpecificAttributes, getSpecificAttributesByCompany, deleteSpecificAttribute } = useSpecificAttributeStore();

    const [loading, setLoading] = useState(false);
    const [attributes, setAttributes] = useState<any>([]);
    const [rowSelected, setRowSelected] = useState<any>('');
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false);
    const [searchTimeout, setSearchTimeout] = useState<any>(null);

    useEffect(() => {
        getSpecificAttributesApi()
    },[])

    const getSpecificAttributesApi = async(search='') => {
        try {
            setLoading(true);
            const response = await getSpecificAttributesByCompany(search);
            if(!response){
                setAttributes([]);
                setLoading(false);
                return false;
            }else{
                setAttributes(response || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const onAdd = () => {
        setActionSpecificAttribute('add');
        setShowModal(true);
    }
    const onEdit = (rowSelected:any) => {
        setActionSpecificAttribute('edit');
        setRowSelected(rowSelected);
        setShowModal(true);
    }
    const onDelete = (rowSelected:any) => {
        setActionSpecificAttribute('delete');
        setRowSelected(rowSelected);
        setShowModalConfirm(true);
    }
    const onDetails = (rowSelected:any) => {
        setActionSpecificAttribute('detail');
        setRowSelected(rowSelected);
        setShowModal(true);
    }

    const onDeleteConfirm = async() => {
        if (rowSelected) {
            setLoading(true);
            const response = await deleteSpecificAttribute(rowSelected.id)
            if(response){
                getSpecificAttributesApi();
                setShowModalConfirm(false);
                setLoading(false);
                setRowSelected('');
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    const onSearch = (term) => {
        clearTimeout(searchTimeout)
        setSearchTimeout(
            setTimeout(() => { getSpecificAttributesApi(term)}, 1000)
        )
    }

    const clearState = () => {
        setRowSelected('');
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable 
                    title={'Atributos específicos del producto'}
                    columns={columns} 
                    loading={loading}
                    rows={attributes || []}
                    onRowClick={() => {}}
                    hasOptions
                    onAddFn={onAdd}
                    onAddFnName={'Nuevo atributo específico'}
                    onDetails={onDetails}
                    onDelete={onDelete}
                    onEdit={onEdit}
                    onSearch={onSearch}
                    dense
                />
            </Grid>
            {
                showModal && (
                    <SpecificAttributesModal
                        open = {showModal}
                        closeModal = {() => {setShowModal(false)}}
                        attributeSelected = {rowSelected}
                        listAttributeUse = {getSpecificAttributesApi}
                        clearState = {clearState}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={()=>{ setShowModalConfirm(false); clearState()}}
                        onConfirm={onDeleteConfirm}
                        status={loading}
                    />
                )
            }
        </>
    )
}